export default "__VITE_ASSET__Bpxh1trm__"